import { Helmet } from "react-helmet-async";
import { useRecoilValue } from "recoil";
import { filterState } from "../atoms/filter";
import { resultState } from "../atoms/result";
import { searchParamsState } from "../atoms/searchParams";

export let info = { title: "", description: "" };

// HTML Header에 관해서
// React Helmet VS React Async Helmet
// React Helmet은 비동기적으로 헤더를 수정하여 만약 수정하는 동안 데이터가 바뀔 경우 바뀐 데이터로
// React Helmet의 내용이 수정됨을 보장할 수 없음
// 하지만 React Async Helmet의 경우엔 비동기적으로 헤더를 수정해서 수정하는동안 데이터가 바뀔 경우에도
// 문제없이 수정됨

export default function HtmlHeader() {
  const result_data = useRecoilValue(resultState);
  const params = useRecoilValue(searchParamsState);
  const filter = useRecoilValue(filterState);
  const addr = filter.locationMode === 1 ? params.addr.replace("+", "") : "";

  // useGtag(result_data);

  // if (
  //   !window.location.href.includes("localhost") &&
  //   process.env.NODE_ENV === "production"
  // ) {
  //   ReactGA.initialize("UA-46679784-1");
  // }

  // useEffect(() => {
  //   if (result_data && !result_data.poi_section) return;
  //   // setFilter((s) => ({ ...s, subTitle: paramArr.join(" ") }));
  //   if (result_data) {
  //     if (document.title === titleStr) {
  //       const GAlog = window.location.pathname + window.location.search;
  //       if (
  //         !window.location.href.includes("localhost") &&
  //         process.env.NODE_ENV === "production" &&
  //         GAlog !== "/"
  //       ) {
  //         setTimeout(() => {
  //           ReactGA.pageview(window.location.pathname + window.location.search);
  //         }, 400);
  //       }
  //     }
  //   }
  // }, [result_data]);

  if (result_data && !result_data.poi_section) {
    return (
      /* @ts-ignore */
      <Helmet>
        <title>빅데이터 맛집검색 - 다이닝코드</title>
        <meta name="description" content="검색 결과가 없습니다."></meta>
      </Helmet>
    );
  }

  if (params.keyword && params.keyword.length > 0) {
    // 카테고리별 순서 로직

    const filterMap = new Map<string, any[]>();
    try {
      params.keyword.forEach((e: any) => {
        let spaceFilter = "";

        if (e === "60대 이상") {
          spaceFilter = e.replace(/(\s*)/g, "");
        } else {
          spaceFilter = e;
        }

        const idx = result_data?.search_filter.findIndex((item: any) =>
          JSON.stringify(item).includes(spaceFilter)
        );

        if (result_data && idx && idx > -1) {
          const filterList = filterMap.get(
            result_data.search_filter[idx].group
          );
          if (filterList) filterList?.push(spaceFilter);
          else
            filterMap.set(result_data.search_filter[idx].group, [spaceFilter]);
        }
      });
    } catch (e) {}
  }

  // title 조합

  let titleParam = "";

  if (
    result_data?.poi_section.full_title &&
    result_data.poi_section.full_title !== " "
  ) {
    titleParam += result_data.poi_section.full_title;
  }

  let titleStr = "";
  let descriptLimit = "";
  if (
    result_data &&
    result_data.poi_section &&
    result_data.poi_section.total_cnt &&
    result_data.poi_section.list
  ) {
    titleStr = `${titleParam.length > 0 ? `'${titleParam}' ` : ""}${
	  result_data.poi_section.search_type == "ranking_search" ? "맛집 빅데이터 추천순위 Top" : (result_data.poi_section.search_type == "addr_search" ? "주소 검색 결과 " : "식당명 검색 결과 ")
    }${
      result_data.poi_section.total_cnt >= 100
        ? "100"
        : result_data.poi_section.total_cnt
    }${
		result_data.poi_section.search_type == "ranking_search" ? "" : "곳"
	} - 다이닝코드`;

    const poiInfoStr = result_data.poi_section.list
      .slice(0, 3)
      .map(
        (item: any) =>
          `${item.nm} ${item.branch ? item.branch : ""}(${
            item.category.replace("<em>", "").replace("</em>", "").split(",")[0]
          }${item.user_score ? ", ★" + item.user_score : ""})`
      )
      .join(", ");

    const descriptionStr = `${titleParam.length > 0 ? `'${titleParam}' ` : ""}${
		result_data.poi_section.search_type == "ranking_search" ? "맛집 " : (result_data.poi_section.search_type == "addr_search" ? "주소 검색 결과 " : "식당명 검색 결과 ")
    }${poiInfoStr} 등 ${
      result_data.poi_section.total_cnt < 10000
        ? `${result_data.poi_section.total_cnt.toLocaleString("en-US")}곳`
        : "10,000곳 이상"
    }의 전체 순위,식당정보,방문자리뷰,사진 등을 확인하세요.`;

    if (descriptionStr.length >= 150) {
      descriptLimit = descriptionStr.substring(0, 150) + "...";
    } else {
      descriptLimit = descriptionStr;
    }

    info = { title: titleStr, description: descriptLimit };

    document.title = titleStr;
  }
  const poiImg = result_data?.poi_section?.list?.[0]?.image || 
    result_data?.poi_section?.list?.[0]?.image_list?.[0] ||
    "https://dfzrjox9sv97l.cloudfront.net/dicons_20160930/img/diningcode_share.jpg";

  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        <meta name="description" content={descriptLimit}></meta>

        {/* og */}
        <meta property="og:title" content={titleStr}></meta>
        <meta property="og:description" content={descriptLimit}></meta>
        <meta property="og:url" content={window.location.href}></meta>
		<meta property="og:image" content={poiImg}></meta>
        {/* og */}

        {/* tw */}
        <meta name="twitter:title" content={titleStr}></meta>
        <meta name="twitter:description" content={descriptLimit}></meta>
        <meta name="twitter:url" content={window.location.href}></meta>

        {/* tw */}
        {window.location.pathname.match(/^\/l-([a-zA-Z0-9\-]+)\.html$/) ? (
          <link
            rel="canonical"
            href={`${window.location.origin}/list.dc?query=${encodeURIComponent(result_data?.params.query || '')}`}></link>
        ) : (
          <link rel="canonical" href={window.location.href}></link>
        )}
      </Helmet>
    </>
  );
}
